import React from 'react';

class SmartTag extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      newtag_input: null,
      newtag_input_value: '',
      newtag_input_title: '',
      newtag_input_autocomplete: '',
      newtag_autocomplete_items: null,
    };

    // this.handleChangeId = this.handleChangeId.bind(this);
    // this.handleChangeTitle = this.handleChangeTitle.bind(this);

    this.autocomplete = this.autocompleteCall.bind(this);
  }

  handleChangeId(tags, tagIdx, rowId, e) {
    let tag_data = tags[this.props.tagId[tagIdx].id];
    tag_data[rowId].id = e.target.value;
    if (tag_data.length && tag_data[tag_data.length - 1].id !== '') {
      tag_data.push({
        id: '',
        title: '',
      });
    }
    tags[this.props.tagId[tagIdx].id] = tag_data;

    this.props.onChange(tags);
  }

  handleChangeTitle(tags, tagIdx, rowId, e) {
    let tag_data = tags[this.props.tagId[tagIdx].id];
    tag_data[rowId].title = e.target.value;
    if (tag_data.length && tag_data[tag_data.length - 1].id !== '') {
      tag_data.push({
        id: '',
        title: '',
      });
    }
    tags[this.props.tagId[tagIdx].id] = tag_data;

    this.props.onChange(tags);
  }

  getSaveData(tags) {
    let data = {};

    for (let tag in tags) {
      let tag_data = [];
      for (let j = 0; j < tags[tag].length; j++) {
        if (tags[tag][j].id !== '' && tags[tag][j].title !== '') {
          tag_data.push(tags[tag][j]);
        }
        if (tag_data.length) {
          data[tag] = tag_data;
        }
      }
    }

    return data;
  }

  removeTag(tags, tagId_id, idx) {
    let tag_data = tags[tagId_id];
    let new_data = [];
    for (let i = 0; i < tag_data.length; i++) {
      if (i !== idx) {
        new_data.push(tag_data[i]);
      }
    }
    tags[tagId_id] = new_data;

    this.props.onChange(tags);
  }

  newtagSelectOnchange(e) {
    this.setState({ newtag_input: e.target.value });
  }

  inputDefaultOnChangeValue(e) {
    this.setState({ newtag_input_value: e.target.value });
  }

  inputAutocompleteOnChange(e) {
    let url;
    let term = e.target.value;
    this.setState({ newtag_input_autocomplete: term });
    if (term.length >= 1) {
      // ak by bolo treba obmedzenie na pocet znakov
      for (let i = 0; i < this.props.tagId.length; i++) {
        if (this.props.tagId[i].id === this.state.newtag_input) {
          url = this.props.tagId[i].autocomplete;
        }
      }
      const final_url = `/api-futbalnet/${url}?term=${term}`;

      this.autocompleteCall(final_url)
        .then(response => {
          this.setState({ newtag_autocomplete_items: response });
        })
        .catch(error => {
          console.log(error);
          alert(error.details.description);
        });
    }
  }

  autocompleteCall(url) {
    return fetch(url, { method: 'get' })
      .then(response => {
        if (response.status >= 200 && response.status < 300) {
          return response.json();
        } else {
          var error = new Error(response.statusText);
          error.response = response;
          throw error;
        }
      })
      .catch(error => {
        return error.response.json().then(error_details => {
          error.details = error_details;
          throw error;
        });
      });
  }

  inputSelectOnChange(e) {
    this.setState({
      newtag_input_value: e.target.value,
      newtag_input_title: e.target.options[e.target.selectedIndex].text,
    });
  }

  addNewTag(tags) {
    if (
      this.state.newtag_input !== '' &&
      this.state.newtag_input_value !== ''
    ) {
      let tag_data = tags[this.state.newtag_input];
      tag_data.push({
        id: this.state.newtag_input_value,
        title: this.state.newtag_input_title,
      });
      tags[this.state.newtag_input] = tag_data;

      this.props.onChange(tags);
      this.setState({ newtag_input_value: '', newtag_input_title: '' });
    }
  }

  autocompleteSelectItem(tags, id, title) {
    if (id !== '' && title !== '') {
      let tag_data = tags[this.state.newtag_input];
      tag_data.push({
        id: id,
        title: title,
      });
      tags[this.state.newtag_input] = tag_data;

      this.props.onChange(tags);
      this.setState({
        newtag_input_value: '',
        newtag_input_title: '',
        newtag_autocomplete_items: null,
        newtag_input_autocomplete: '',
      });
    }
  }

  render() {
    var tags = {};
    for (let i = 0; i < this.props.tagId.length; i++) {
      var tag_data = [];
      if (this.props.article[this.props.tagId[i].id]) {
        tag_data = this.props.article[this.props.tagId[i].id];
      }
      // if (!tag_data.length || (tag_data.length && tag_data[tag_data.length - 1].id !== "")) {
      //     tag_data.push({
      //         id: "",
      //         title: ""
      //     });
      // }
      tags[this.props.tagId[i].id] = tag_data;
    }

    let tagId = [];

    for (let i = 0; i < this.props.tagId.length; i++) {
      let tagId_id = this.props.tagId[i].id;
      let rowInput = [];

      if (tags) {
        for (let j = 0; j < tags[tagId_id].length; j++) {
          rowInput.push(
            /*
                        <div key={String(tagId_id) + String(j)} className="col-xs-12 form-group">
                            <div className="col-xs-6">
                                <input className="form-control" name="_id" value={tags[tagId_id][j].id} onChange={this.handleChangeId.bind(this, tags, i, j)} type="text" placeholder="Id" />
                            </div>
                            <div className="col-xs-6">
                                <input className="form-control" name="title" value={tags[tagId_id][j].title} onChange={this.handleChangeTitle.bind(this, tags, i, j)} type="text" placeholder="Názov"/> 
                            </div>
                        </div>
                        */
            <span
              key={String(tagId_id) + String(j)}
              className="btn btn-default btn-mrg"
            >
              {tags[tagId_id][j].title !== '' ? (
                <span>
                  {tags[tagId_id][j].title} ({tags[tagId_id][j].id})
                </span>
              ) : (
                <span>{tags[tagId_id][j].id}</span>
              )}
              &nbsp;
              <a
                href="javascript:;"
                className="text-danger"
                onClick={this.removeTag.bind(this, tags, tagId_id, j)}
              >
                <span className="fa fa-times" />
              </a>
              <input type="hidden" value={tags[tagId_id][j].id} />
            </span>,
          );
        }

        if (rowInput.length) {
          tagId.push(
            <div className="form-group clearfix" key={tagId_id}>
              <div className="col-md-3">
                <strong>{this.props.tagId[i].title}</strong>
              </div>
              <div className="col-md-9">{rowInput}</div>
            </div>,
          );
        }
      }
    }

    let newtaginput;
    let show_newtaginput_plus = false;
    if (this.state.newtag_input !== '') {
      let tag;
      for (let i = 0; i < this.props.tagId.length; i++) {
        if (this.props.tagId[i].id === this.state.newtag_input) {
          tag = this.props.tagId[i];
        }
      }
      if (tag) {
        if (tag.autocomplete) {
          let autocompelete_data;
          if (
            this.state.newtag_autocomplete_items &&
            this.state.newtag_autocomplete_items.length
          ) {
            let items = [];
            for (
              let i = 0;
              i < this.state.newtag_autocomplete_items.length;
              i++
            ) {
              items.push(
                <li key={this.state.newtag_autocomplete_items[i].id}>
                  <a
                    href="javascript:;"
                    onClick={this.autocompleteSelectItem.bind(
                      this,
                      tags,
                      this.state.newtag_autocomplete_items[i].id,
                      this.state.newtag_autocomplete_items[i].label,
                    )}
                  >
                    {this.state.newtag_autocomplete_items[i].label}
                  </a>
                </li>,
              );
            }
            autocompelete_data = (
              <div className="form-control autocomplete-results">
                <ul>{items}</ul>
              </div>
            );
          }
          newtaginput = (
            <div className="autocomplete-container">
              <input
                className="form-control"
                placeholder="Začnite písať meno..."
                value={this.state.newtag_input_autocomplete}
                onChange={this.inputAutocompleteOnChange.bind(this)}
              />
              {autocompelete_data}
            </div>
          );
        } else if (tag.values) {
          let options = [];
          options.push(
            <option key="0" value="">
              - vyberte zo zoznamu -
            </option>,
          );
          for (let i = 0; i < tag.values.length; i++) {
            options.push(
              <option key={tag.values[i].id} value={tag.values[i].id}>
                {tag.values[i].title}
              </option>,
            );
          }
          newtaginput = (
            <select
              className="form-control"
              onChange={this.inputSelectOnChange.bind(this)}
            >
              {options}
            </select>
          );
          show_newtaginput_plus = true;
        } else {
          newtaginput = (
            <input
              type="text"
              className="form-control"
              placeholder="Napíšte kľúčové slovo"
              value={this.state.newtag_input_value}
              onChange={this.inputDefaultOnChangeValue.bind(this)}
            />
          );
          show_newtaginput_plus = true;
        }
      }
    } else {
      newtaginput = null;
    }

    let newtagoptions = [];
    for (let i = 0; i < this.props.tagId.length; i++) {
      newtagoptions.push(
        <option key={this.props.tagId[i].id} value={this.props.tagId[i].id}>
          {this.props.tagId[i].title}
        </option>,
      );
    }

    let newtag = (
      <div className="form-group clearfix">
        <div className="col-md-3">
          <select
            className="form-control"
            onChange={this.newtagSelectOnchange.bind(this)}
          >
            <option value="">- vyberte typ -</option>
            {newtagoptions}
          </select>
        </div>
        <div className="col-md-6">{newtaginput}</div>
        <div className="col-md-2">
          {newtaginput && show_newtaginput_plus ? (
            <a
              href="javascript:;"
              className="btn btn-default btn-sm"
              onClick={this.addNewTag.bind(this, tags)}
            >
              <span className="fa fa-plus" />
            </a>
          ) : null}
        </div>
      </div>
    );

    return (
      <div>
        {tagId}
        {newtag}
      </div>
    );
  }
}

SmartTag.defaultProps = {
  tagId: [
    {
      id: 'clubs',
      title: 'Kluby',
    },
    {
      id: 'persons',
      title: 'Osoby',
    },
    {
      id: 'competitions',
      title: 'Súťaže',
    },
  ],
};

export default SmartTag;



// WEBPACK FOOTER //
// ./src/js/app/cm/components/SmartTag.jsx